/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


export const alphabetizeObjectsByKey = (data: any[], key: string): any[] => {
  return data.sort((a: any,b: any) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0));
};
